import { ChangeEvent, Dispatch, FC, memo, SetStateAction, useCallback } from 'react'
import { Input } from '@chakra-ui/react'

import { FormItem, MaskedInput } from 'components'
import CustomSelect from './components/Select'
import { FilterGroupInputsProps } from '../..'

type PossibleFields = {
  [key: string]: JSX.Element
}

type CitizenFilterWithKey = any & {
  [key: string]: string
}

type Props = {
  index: number
  field: FilterGroupInputsProps
  values: CitizenFilterWithKey
  setValues: Dispatch<SetStateAction<CitizenFilterWithKey>>
}

const FilterInput: FC<Props> = ({ index, field, values, setValues }) => {
  function handleOnChangeInput(event: ChangeEvent<HTMLInputElement>) {
    const { name, value } = event.target
    setValues({ ...values, [name]: value })
  }

  function handleOnChangeSelect(event: ChangeEvent<HTMLSelectElement>) {
    const { name, value } = event.target
    setValues({ ...values, [name]: value })
  }

  const RenderField = useCallback(
    ({ name, options, mask, ...rest }: FilterGroupInputsProps) => {
      const possibleFiels: PossibleFields = {
        INPUT: <Input {...rest} name={name} value={values[name]} onChange={handleOnChangeInput} />,
        MASKED_INPUT: <MaskedInput {...rest} mask={mask} name={name} value={mask && mask(values[name])} onChange={handleOnChangeInput} />,
        SELECT: <CustomSelect {...rest} options={options} name={name} value={values[name]} onChange={handleOnChangeSelect} />,
      }

      return possibleFiels[rest.type]
    },
    [values]
  )

  return (
    <FormItem key={field.name} label={field.label} htmlFor={`field_${index}`}>
      {RenderField({ ...field, id: index === 0 ? 'first-input' : field.name })}
    </FormItem>
  )
}

export default memo(FilterInput)
